<template>
    <v-container>
       <v-row justify="center">
         <v-col cols="12" sm="8" md="5">
           <v-card>
             <v-card-title class="text-h5 text-center pa-4">Kayıt Ol</v-card-title>
             <v-card-text>
                <v-alert v-if="error" type="error" dense dismissible class="mb-4">
                 {{ error }}
               </v-alert>
               <v-form @submit.prevent="handleRegister" ref="registerForm">
                 <v-text-field
                   v-model="formData.username"
                   label="Kullanıcı Adı"
                   required
                   :rules="[rules.required, rules.minLength(3)]"
                   prepend-icon="mdi-account"
                   counter="50"
                 ></v-text-field>
                  <v-text-field
                   v-model="formData.email"
                   label="E-posta Adresi"
                   type="email"
                   required
                   :rules="[rules.required, rules.email]"
                   prepend-icon="mdi-email"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.password"
                   label="Şifre"
                   type="password"
                   required
                   :rules="[rules.required, rules.minLength(6)]"
                   prepend-icon="mdi-lock"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.passwordConfirm"
                   label="Şifre Tekrar"
                   type="password"
                   required
                   :rules="[rules.required, passwordMatch]"
                   prepend-icon="mdi-lock-check"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.profile_title"
                   label="Mesleki Ünvan (Opsiyonel)"
                   placeholder="Diş Hekimi, Teknisyen, Ortodontist vb."
                   prepend-icon="mdi-briefcase"
                 ></v-text-field>
   
                 <v-btn
                   type="submit"
                   color="primary"
                   block
                   large
                   class="mt-4"
                   :loading="isLoading"
                   :disabled="isLoading"
                 >
                   Kayıt Ol
                 </v-btn>
               </v-form>
             </v-card-text>
              <v-card-actions class="justify-center pb-4">
                  Zaten hesabınız var mı? <v-btn small text color="primary" to="/login" class="pl-1">Giriş Yapın</v-btn>
               </v-card-actions>
           </v-card>
         </v-col>
       </v-row>
     </v-container>
   </template>
   
   <script>
   import { mapActions, mapGetters } from 'vuex';
   
   export default {
     name: 'RegisterView',
      data() {
       return {
         formData: {
           username: '',
           email: '',
           password: '',
           passwordConfirm: '',
           profile_title: '',
         },
         rules: {
           required: value => !!value || 'Bu alan zorunludur.',
           minLength: (length) => (value) => (value && value.length >= length) || `En az ${length} karakter olmalı.`,
           email: value => /.+@.+\..+/.test(value) || 'Geçerli bir e-posta adresi girin.',
         },
       };
     },
      computed: {
       ...mapGetters(['isLoading', 'error']),
       passwordMatch() {
         return () => (this.formData.password === this.formData.passwordConfirm) || 'Şifreler eşleşmiyor.';
       },
     },
      mounted() {
        // Hata varsa temizle
        this.$store.commit('CLEAR_ERROR');
      },
     methods: {
        ...mapActions('auth', ['register']),
        async handleRegister() {
           this.$store.commit('CLEAR_ERROR');
           const { valid } = await this.$refs.registerForm.validate();
            if (valid) {
               try {
                    // passwordConfirm'i gönderme
                    const userData = {
                        username: this.formData.username,
                        email: this.formData.email,
                        password: this.formData.password,
                        // profile_title boş değilse ekle, boşsa gönderme (opsiyonel iyileştirme)
                        profile_title: this.formData.profile_title || undefined
                    };
                    await this.register(userData);
                    // Başarılı olursa action Login'e yönlendirir.
               } catch (err) {
                    console.error("Register component error:", err);
               }
            }
        }
     }
   }
   </script>